import React from "react";
import { useTranslation } from "react-i18next";
import toFarsiNumber from "util/toFarsiNumber";
import PersianPrice from "../Header/PersianPrice";

const InvoiceDetailsProduct = ({ detailData, classes }) => {
  const { t, i18n } = useTranslation();
  const { orders } = detailData;
  return (
    <div className="rounded border p-2 my-3 d-flex flex-column  align-items-center">
      <div className="d-none d-md-flex w-100 flex-row ">
        <div className="col col-lg-4"></div>
        <div className="col col-lg-8 d-flex flex-row justify-content-between ">
          <p
            className={`${
              i18n.dir() === "rtl" ? "text-left" : "text-right"
            } col col-lg-3`}
          >
            {t("invoices.unit_price")}
          </p>
          <p
            className={`${
              i18n.dir() === "rtl" ? "text-left" : "text-right"
            } col col-lg-3`}
          >
            {t("invoices.arithmetic_unit")}
          </p>
          <p
            className={`${
              i18n.dir() === "rtl" ? "text-left" : "text-right"
            } col col-lg-3`}
          >
            {t("invoices.rate_of_usage")}
          </p>
          <p
            className={`${
              i18n.dir() === "rtl" ? "text-left" : "text-right"
            } col col-lg-3`}
          >
            {t("invoices.total")}
          </p>
        </div>
      </div>
      {orders.map((item, index) => (
        <div
          style={{ borderRadius: "0.5rem" }}
          className={`${classes.mainContainer} w-100 border p-2 m-2  justify-content-between align-items-center`}
        >
          <div
            className={`${classes.itemFlexBasis} col col-lg-4 d-flex flex-row `}
          >
            <div className="px-2">
              <span className={classes.itemIndex}>
                {toFarsiNumber(index + 1)}
              </span>
            </div>
            <div>{item.product.title}</div>
          </div>
          <div className={`${classes.itemContainerProduct} col col-lg-8 `}>
            <div
              className={`${classes.itemFlexBasis} ${
                i18n.dir() === "rtl" ? "text-left" : "text-right"
              } col col-lg-3`}
            >
              <span className={classes.mobileTitle}>
                {t("invoices.unit_price")}:{" "}
              </span>
              <span className={classes.floatLeft}>
                <PersianPrice number={Math.floor(item.product.price)} />
                <span className={classes.rial}> {t("invoices.rial")} </span>
              </span>
            </div>
            <div
              className={`${classes.itemFlexBasis} ${
                i18n.dir() === "rtl" ? "text-left" : "text-right"
              } col col-lg-3`}
            >
              <span className={classes.mobileTitle}>
                {" "}
                {t("invoices.arithmetic_unit")} :{" "}
              </span>
              <span className={classes.floatLeft}>
                {item.product.unit === "HOUR" ? t("invoices.hour") : "-"}
              </span>
            </div>
            <div
              className={`${classes.itemFlexBasis} ${
                i18n.dir() === "rtl" ? "text-left" : "text-right"
              } col col-lg-3`}
            >
              <span className={classes.mobileTitle}>
                {t("invoices.rate_of_usage")}:{" "}
              </span>
              <span className={classes.floatLeft}>
                <PersianPrice number={Math.floor(item.quantity)} />
              </span>
            </div>
            <div
              className={`${classes.itemFlexBasis} ${classes.priceMobile} col col-lg-3  flex-row align-items-center`}
            >
              <span className={classes.mobileTitle}>
                {t("invoices.total")}:{" "}
              </span>
              <span
                className={classes.floatLeft}
                style={{
                  display: "flex",
                  width: "fit-content",
                  backgroundColor: "rgba(0, 150, 136,0.1)",
                  borderRadius: " 0.6em",
                  padding: "0.5em ",
                  // margin: "0 auto",
                  left: "0px",
                  color: "rgba(0, 186, 186, 1)",
                }}
              >
                <PersianPrice number={Math.floor(item.total)} />
                <span className={classes.rial}> {t("invoices.rial")} </span>
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InvoiceDetailsProduct;
